import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavbarService } from '../../services/navbar.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '../../services/client.service';
import { ClientModel } from '../../models/client.model';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { StorageService } from '../../services/storage.service';
import { ClaimsService } from '../../services/claims.service';

@Component({
    selector: 'top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {

    subscriptions: Subscription[] = [];
    clients: ClientModel[] = [];
    allClients: ClientModel[] = [];
    currentClient: ClientModel = new ClientModel();
    clientId: number;
    form: UntypedFormGroup;
    showClientSelect: boolean = false;
    isAdmin: boolean = false;
    isLoggedIn: boolean = false;

    constructor(
        private claimsService: ClaimsService,
        private route: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private clientService: ClientService,
        private router: Router,
        private navBarService: NavbarService,
        private storageService: StorageService
    ) {
        this.form = fb.group({
            'clientId': [this.route.snapshot.params.clientId, null]
        });
    }

    ngOnInit() {
        try {
            this.isAdmin = this.claimsService.isAdmin();
        } catch { }

        this.showClientSelect = this.getUrl().includes(':clientId') && !this.isAdmin ;

        this.isLoggedIn = this.storageService.getItem("token") != undefined;

        if (this.isLoggedIn) {
            this.clientService.all().then(
                result => {
                    this.clients = result;
                });
        }

        this.clientId = this.route.snapshot.params.clientId;

        this.form.controls.clientId.valueChanges.subscribe(
            value => {
                // build url path
                let urlParts = [];
                let item = this.route.snapshot.parent.firstChild;
                while (item != null) {
                    urlParts.push(item.routeConfig.path);
                    item = item.firstChild;
                }

                // replace clientId in path
                let url = urlParts.join('/')
                url = url.replace(':clientId', value.toString());

                // truncate to first unknown url param, redirect
                url = url.split('/:')[0];

                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                    this.router.navigate([url])
                );
            }
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private getUrl(): string {
        // build url path
        let urlParts = [];
        let item = this.route.snapshot.parent.firstChild;
        while (item != null) {
            urlParts.push(item.routeConfig.path);
            item = item.firstChild;
        }

        // replace clientId in path
        return urlParts.join('/');
    }

    toggleNavBar() {
        this.navBarService.toggleSubject.next(null);
    }
}
